import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsCommunity, NewsCommunityApproveAutomaticallyRequest, NewsCommunityResponse } from '@models/news-article';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable()
export class NewsCommunitiesService {
  private readonly url = `${environment.bffUrl}/news-communities`;
  constructor(private http: HttpClient) {}
  getAll(): Observable<NewsCommunity[]> {
    return this.http.get<NewsCommunityResponse[]>(this.url);
  }
  getOne(id: string): Observable<NewsCommunity> {
    return this.http.get<NewsCommunityResponse>(`${this.url}/${id}`);
  }
  toggleAutomaticApproval(id: string, req: NewsCommunityApproveAutomaticallyRequest): Observable<NewsCommunity> {
    return this.http.post<NewsCommunityResponse>(`${this.url}/${id}/approve-news-automatically`, req);
  }
}
